const currentDate = new Date()
const vouchers = {
  permissionSource: 'api::voucher.voucher',
  creationTitle: 'Create Voucher',
  creationEndPoint: '/vouchers',
  listingTitle: 'Vouchers',
  listingEndPoint: '/vouchers?sort[0]=createdAt:DESC',
  listingCollectibleRoute: '/vouchers/:id',
  listing: [
    { title: 'Code', value: 'code', class: 'text-center' },
    { title: 'Title', value: 'title', class: '', isHTML: true },
    { title: 'Largest Amount', value: 'largestAmount', class: 'text-center', sorting: false },
    { title: 'Voucher Type', value: 'voucher_type.data.attributes.label', class: '' },
    { title: 'Transaction Date', value: 'date', class: '' },
  ],
  listingDefaultFilterOptions: [
    {
      label: 'Code',
      key: 'code',
      tag: 'input',
      operator: 'contains',
    },
    {
      label: 'Title',
      key: 'title',
      tag: 'input',
      operator: 'contains',
    },
    {
      label: 'Transaction Date',
      key: 'date',
      tag: 'date-range-picker',
      operator: 'contains',
    },
    {
      label: 'Voucher Type',
      key: 'voucher_type.id',
      tag: 'single-select',
      dataSourceUrl: '/voucher-types',
      dataLabel: 'label',
      operator: 'eq',
    },
  ],
  detailTitle: 'Voucher: :title',
  detailEndPoint:
    '/vouchers/:id?populate[0]=voucher_type&populate[1]=voucher_items.attachment&populate[2]=voucher_items.ledger',
  detail: [
    {
      isLayout: true,
      layoutPattern: '1-1',
      children: [
        {
          label: 'Code',
          value: 'code',
          tag: 'input',
          type: 'text',
          placeholder: 'Voucher Code',
          required: true,
        },
        {
          label: 'Title',
          value: 'title',
          tag: 'textarea',
          placeholder: 'Voucher Title',
          required: true,
        },
      ],
    },
    {
      label: 'Voucher Type',
      value: 'voucher_type',
      tag: 'single-select',
      dataSourceUrl: '/voucher-types',
      dataLabel: 'label',
      required: true,
    },
    {
      label: 'Transaction Date',
      value: 'date',
      tag: 'date-picker',
      required: true,
    },
    {
      isLayout: true,
      layoutPattern: '1-1-1',
      children: [
        {
          label: 'Create Date / Time',
          value: 'custom_created_at',
          tag: 'static-text',
        },
        {
          label: 'Publish Date / Time',
          value: 'publishedAt',
          tag: 'static-text',
        },
        {
          label: 'Update Date / Time',
          value: 'custom_updated_at',
          tag: 'static-text',
        },
      ],
    },
  ],
  creationData: {
    date: currentDate,
  },
}
export default vouchers
